import { render, staticRenderFns } from "./softwareTool.vue?vue&type=template&id=7295aee1&scoped=true&"
import script from "./softwareTool.vue?vue&type=script&lang=js&"
export * from "./softwareTool.vue?vue&type=script&lang=js&"
import style0 from "./softwareTool.vue?vue&type=style&index=0&lang=css&"
import style1 from "./softwareTool.vue?vue&type=style&index=1&id=7295aee1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7295aee1",
  null
  
)

export default component.exports